export default function IdentityAndReasonSection({
  values,
  errors,
  handleChange,
  labelStyle,
  inputStyle,
}) {
  const hasCensusGroup =
    values.censusNumber || values.censusDate || values.leaveBy;

  const hasIdCardGroup =
    values.identityCardNumber || values.dateCard || values.leaveByCard;

  return (
    <>
      <label
        className="m-1 mt-4"
        style={{
          ...labelStyle,
          fontSize: "clamp(0.9rem, 1.2vw, 1.1rem)",
          textAlign: "center",
          display: "block",
          width: "100%",
          textDecoration: "underline",
          textUnderlineOffset: "3px",
        }}
      >
        ບັດປະຈຳຕົວ ຫຼື ສຳມະໂນຄົວໃຫ້ເລືອກຢ່າງໃດຢາງໜຶ່ງໄດ້
      </label>

      <div className="grid-container">
        {/* ສຳມະໂນຄົວເລກທີ */}
        <div>
          <label style={labelStyle}>
            ສຳມະໂນຄົວເລກທີ
            {((!hasCensusGroup && !hasIdCardGroup) ||
              (hasCensusGroup && !values.censusNumber)) && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="censusNumber"
            value={values.censusNumber}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນເລກທີສຳມະໂນຄົວ"
          />
          {errors.censusNumber && (
            <p className="error-text">{errors.censusNumber}</p>
          )}
        </div>

        {/* ລົງວັນທີ ສຳມະໂນຄົວ */}
        <div>
          <label style={labelStyle}>ລົງວັນທີ</label>
          <input
            type="date"
            name="censusDate"
            value={values.censusDate}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.censusDate && (
            <p className="error-text">{errors.censusDate}</p>
          )}
        </div>

        {/* ອອກໃຫ້ໂດຍ (ສຳມະໂນຄົວ) */}
        <div>
          <label style={labelStyle}>ອອກໃຫ້ໂດຍ</label>
          <input
            type="text"
            name="leaveBy"
            value={values.leaveBy}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນອອກໃຫ້ໂດຍ"
          />
          {errors.leaveBy && (
            <p className="error-text">{errors.leaveBy}</p>
          )}
        </div>

        {/* ບັດປະຈຳຕົວເລກທີ */}
        <div>
          <label style={labelStyle}>
            ບັດປະຈຳຕົວເລກທີ
            {((!hasCensusGroup && !hasIdCardGroup) ||
              (hasIdCardGroup && !values.identityCardNumber)) && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="identityCardNumber"
            value={values.identityCardNumber}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນເລກທີບັດປະຈຳຕົວ"
          />
          {errors.identityCardNumber && (
            <p className="error-text">{errors.identityCardNumber}</p>
          )}
        </div>

        {/* ລົງວັນທີ ບັດປະຈຳຕົວ */}
        <div>
          <label style={labelStyle}>ລົງວັນທີ</label>
          <input
            type="date"
            name="dateCard"
            value={values.dateCard}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.dateCard && (
            <p className="error-text">{errors.dateCard}</p>
          )}
        </div>

        {/* ອອກໃຫ້ໂດຍ (ບັດປະຈຳຕົວ) */}
        <div>
          <label style={labelStyle}>ອອກໃຫ້ໂດຍ</label>
          <input
            type="text"
            name="leaveByCard"
            value={values.leaveByCard}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນອອກໃຫ້ໂດຍ"
          />
          {errors.leaveByCard && (
            <p className="error-text">{errors.leaveByCard}</p>
          )}
        </div>
      </div>

      {/* ເຫດຜົນທີ່ຢາກເຂົ້າເຮັດວຽກ */}
      <div style={{ marginTop: "1.3rem" }}>
        <label style={labelStyle}>
          ເຫດຜົນທີ່ຢາກເຂົ້າເຮັດວຽກຢູ່ ບໍລິສັດ ອານຸສິດ ຈຳກັດ{" "}
          {!values.reasontobecome && (
            <span style={{ color: "red", marginLeft: 4 }}>*</span>
          )}
        </label>
        <textarea
          name="reasontobecome"
          value={values.reasontobecome}
          onChange={handleChange}
          rows={3}
          style={{ ...inputStyle, resize: "vertical" }}
          placeholder="ເຫດຜົນທີ່ຢາກເຂົ້າເຮັດວຽກ..."
        />
        {errors.reasontobecome && (
          <p className="error-text">{errors.reasontobecome}</p>
        )}
      </div>

      {/* ຄວາມສາມາດພິເສດດ້ານອື່ນໆ */}
      <div style={{ marginTop: "1.3rem" }}>
        <label style={labelStyle}>ຄວາມສາມາດພິເສດດ້ານອື່ນໆ</label>
        <textarea
          name="specialSkillOther"
          value={values.specialSkillOther}
          onChange={handleChange}
          rows={3}
          style={{ ...inputStyle, resize: "vertical" }}
          placeholder="ບອກພວກເຮົາເພີ່ມເຕີມກ່ຽວກັບຄວາມສາມາດພິເສດດ້ານອື່ນໆທີ່ມີ..."
        />
      </div>
    </>
  );
}